import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 30000,
});

api.interceptors.request.use((config) => {
  const stored = localStorage.getItem("atom.user");
  if (stored) {
    try {
      const u = JSON.parse(stored);
      config.headers["X-User-Email"] = u.email;
    } catch {}
  }
  return config;
});
